// no imports!

export const TITLE = "Infinite Ascent";
export const DESCRIPTION = "The blog of CJ Quines.";
export const SITE_URN = "blog.cjquines.com";
export const SITE_URL = `https://${SITE_URN}`;
export const BASE_SITE_URL = `https://cjquines.com`;
export const SUBSCRIBE_URL =
  "https://cjquines.aweb.page/p/0a2d21f0-276f-42a1-87d2-c9bf8b345386";
export const TIMEZONE = "America/New_York";
